import { EMAIL } from "@/data/photos";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#E8E2D5] px-6 py-16 md:px-12 md:py-20"
  >
    <div className="flex flex-col items-start gap-4">
      <p className="overline-label">Commissions &amp; enquiries</p>
      <a
        href={`mailto:${EMAIL}`}
        data-testid="footer-email-link"
        className="font-body text-sm underline decoration-[#E8E2D5] underline-offset-4 transition-opacity duration-500 hover:opacity-40"
      >
        {EMAIL}
      </a>
    </div>
    <div className="mt-14 flex flex-col gap-3 border-t border-[#E8E2D5] pt-8 md:flex-row md:items-baseline md:justify-between">
      <p className="font-body text-xs text-muted-foreground">
        &copy; MMXXVI Anna Kidman — All photographs are the artist&rsquo;s own.
      </p>
      <p className="font-body text-xs italic text-muted-foreground">
        Made slowly, printed by hand.
      </p>
    </div>
  </footer>
);

export default Footer;
